export default __webpack_public_path__ + "static/media/new_admission_use_case.b743f9d6.png";